import React from 'react';
import Icon from '../Icon';
import cx from 'classnames';
import {noop} from '@ultradent/utilities/Functions';

const BackButton = ( {children, className, onClick=noop} ) =>
    <span data-testid="Index"
          className={cx( 'flex flex-nowrap items-center flex-0 font-semibold link-hover', className )}
          onClick={onClick}>
        <Icon name="ArrowLeft" width="20" height="20" className="flex-none inline-block mr-2"/>
        {children}
    </span>;

const BackButtonDrawer = ( {children, className, onClick=noop} ) =>
    <span data-testid="BackButtonDrawer"
          className={cx( 'flex items-center flex-0 font-semibold link-hover', className )}
          onClick={onClick}>
        <Icon name="ArrowDown" width="20" height="20" className="flex-none mr-2"/>
        {children}
    </span>;

export {BackButton, BackButtonDrawer}
